import { Task } from '../../../types/task';
import { useTaskManager } from '../../../hooks/userTaskManager';
import { FinishTaskButton } from './FinishTaskButton';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';

interface Props {
    task: Task;
}

export function TaskItem({ task }: Props) {
    const { setOpenDetails, setCurrentTaskId, currentTaskId } = useTaskManager()

    const onOpenTaskDetails = () => {
        if(currentTaskId == task.id) return;

        setOpenDetails(true);
        setCurrentTaskId(task.id);
    }

    return (
        <div 
            onClick={onOpenTaskDetails}
            className="flex gap-x-2 justify-betweens items-center border-[1px] border-gray-300 bg-slate-50 hover:bg-slate-200 rounded-md h-[55px] px-2 py-1 w-full">
                <div className='flex-none'>

                <FinishTaskButton 
                    taskId={task.id}
                    taskStatus={task.terminada} />
                </div>

                <div className='flex flex-col flex-1 overflow-hidden'>

                    <p className="font-semibold select-none truncate">{task.titulo}</p>

                    <div className="flex gap-x-2 items-center">

                        <div className="flex items-center gap-x-1 overflow-hidden">
                            <CalendarTodayRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 13, width: 13 }}/>
                            <p className="text-[13px] select-none h-[20px] truncate">{task.fechaInicial}</p>
                        </div>

                        {task.recordatorioActivado && (
                        <>
                        <div className="h-[5px] w-[5px] bg-gray-600 rounded-full"/>

                        <div className="flex items-center gap-x-1 overflow-hidden">
                            <NotificationsNoneRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 16, width: 16 }}/>
                            <p className="text-[13px] select-none h-[20px] truncate">{task.timeBeforeSendNotification}</p>
                        </div>
                        </>
                        )}
                    </div>
                </div>
        </div>
    );
}